import React, { useEffect, useRef } from "react";

import * as d3 from "d3";

import { colorBands } from "src/organization/pages/project/environment/metrics/constant";
import {
  AdaptedCursor,
  HttpMetricsType
} from "src/organization/pages/project/environment/metrics/http/types";

import { findMetricsValue } from "./util";

type LinePropType = {
  index: number;
  data: HttpMetricsType[];
  xScale: d3.ScaleTime<number, number, never>;
  yScale: d3.ScaleLinear<number, number, never>;
  adaptedCursor?: AdaptedCursor;
};

const Line = (props: LinePropType) => {
  const { data, yScale, xScale, index, adaptedCursor } = props;
  const urlLineRef = useRef<SVGGElement>(null);
  const indicatorRef = useRef<SVGGElement>(null);
  const snapDate = adaptedCursor?.snapDate;

  const getYValue = (d: HttpMetricsType) =>
    findMetricsValue(d, "request.url.method.count")?.sum || 0;

  useEffect(() => {
    const generateLine = d3
      .line<HttpMetricsType>()
      .x(d => xScale(d.date))
      .y(d => yScale(getYValue(d)));

    d3.select(urlLineRef.current)
      .selectAll("path")
      .data([data])
      .join("path")
      .attr("d", generateLine)
      .attr("stroke", colorBands[index])
      .attr("stroke-width", 1.5)
      .attr("class", (d, i) => `dimension_${d[i].dimension}`)
      .attr("fill", "none");

    // Add circle indicators for EVERY data point
    const indicatorGroup = d3.select(indicatorRef.current);
    indicatorGroup
      .selectAll("circle")
      .data(data)
      .join("circle")
      .attr("cx", d => xScale(d.date))
      .attr("cy", d => yScale(getYValue(d)))
      .attr("r", 3)
      .attr("fill", colorBands[index])
      .attr("stroke", "var(--snow)")
      .attr("stroke-width", 1)
      .attr("opacity", ({ date }) =>
        date.getTime() === snapDate?.getTime() ? 1 : 0
      );
  }, [data, xScale, yScale, index, snapDate]);

  return (
    <g>
      <g ref={urlLineRef} />
      <g ref={indicatorRef} />
    </g>
  );
};

export default Line;
